(function () {
	var INVENTORY_API = 'https://boh-oauth-catcher.fourevergreen.workers.dev/inventory';
	var BOLIG_OG_HAVEN = 'Bolig og Haven';

	function countWeekdays(from, to) {
		var count = 0;
		var cur = new Date(from.getTime());
		cur.setHours(0, 0, 0, 0);
		var end = new Date(to.getTime());
		end.setHours(0, 0, 0, 0);
		while (cur <= end) {
			var day = cur.getDay();
			if (day !== 0 && day !== 6) count++;
			cur.setDate(cur.getDate() + 1);
		}
		return count;
	}

	function getHolidayExtraDays(holidays, today) {
		var totalExtra = 0;
		holidays.forEach(function (holiday) {
			if (!holiday.start || !holiday.end) return;
			var start = new Date(holiday.start + 'T00:00:00');
			var end = new Date(holiday.end + 'T00:00:00');
			var from = today > start ? today : start;
			if (from > end) return;
			totalExtra += countWeekdays(from, end);
		});
		return totalExtra;
	}

	function getAdjustedRange(lower, upper, holidays) {
		if (isNaN(lower) || isNaN(upper)) return null;
		var today = new Date();
		today.setHours(0, 0, 0, 0);
		var extra = getHolidayExtraDays(holidays, today);
		return { lower: lower + extra, upper: upper + extra };
	}

	function getHolidays() {
		var el = document.getElementById('cart-delivery-holidays');
		if (!el) return [];
		try {
			return JSON.parse(el.textContent) || [];
		} catch (e) {
			return [];
		}
	}

	function getBaseInterval() {
		var el = document.getElementById('cart-delivery-base');
		if (!el) return { lower: NaN, upper: NaN };
		return {
			lower: parseInt(el.dataset.baseIntervalLower, 10),
			upper: parseInt(el.dataset.baseIntervalUpper, 10),
		};
	}

	var lastSyncedDeliveryEstimate = null;

	function syncDeliveryEstimateAttribute(text) {
		if (text === lastSyncedDeliveryEstimate) return;
		var updateUrl = (window.theme && window.theme.routes && window.theme.routes.cart_update_url) || '/cart/update.js';
		fetch(updateUrl, {
			method: 'POST',
			headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
			body: JSON.stringify({ attributes: { delivery_estimate: text } }),
		})
			.then(function (res) {
				if (!res.ok) throw new Error('bad response');
				lastSyncedDeliveryEstimate = text;
			})
			.catch(function () {});
	}

	function resolveItemStatus(itemEl, locations, holidays, base) {
		var qtyInput = itemEl.querySelector('.qty');
		var qty = qtyInput ? parseInt(qtyInput.value, 10) : 1;
		if (isNaN(qty) || qty < 1) qty = 1;

		var boligHaven = locations[BOLIG_OG_HAVEN] || 0;
		if (boligHaven >= qty) {
			return { range: getAdjustedRange(base.lower, base.upper, holidays), oversold: false };
		}

		var lower = parseInt(itemEl.dataset.intervalLower, 10);
		var upper = parseInt(itemEl.dataset.intervalUpper, 10);
		var lokation = itemEl.dataset.lokation || '';
		var lokationStock = lokation ? (locations[lokation] || 0) : 0;
		var total = boligHaven + lokationStock;

		if (total >= qty) {
			return { range: getAdjustedRange(lower, upper, holidays), oversold: false };
		}

		if (itemEl.dataset.inventoryPolicy === 'continue') {
			return { range: getAdjustedRange(lower, upper, holidays), oversold: false };
		}

		return { range: null, oversold: true, available: total };
	}

	function updateSummary() {
		var summaryEls = document.querySelectorAll('.cart-delivery-estimate');
		var allItemEls = Array.prototype.slice.call(document.querySelectorAll('[data-cart-delivery-item]'));

		if (!allItemEls.length) {
			summaryEls.forEach(function (el) {
				el.hidden = true;
			});
			return;
		}

		var holidays = getHolidays();
		var base = getBaseInterval();

		var byVariant = {};
		allItemEls.forEach(function (itemEl) {
			var variantId = itemEl.dataset.variantId;
			if (!variantId) return;
			if (!byVariant[variantId]) byVariant[variantId] = [];
			byVariant[variantId].push(itemEl);
		});

		var variantIds = Object.keys(byVariant);
		var promises = variantIds.map(function (variantId) {
			var itemEl = byVariant[variantId][0];
			return fetch(INVENTORY_API + '?variant_id=' + variantId)
				.then(function (res) {
					if (!res.ok) throw new Error('bad response');
					return res.json();
				})
				.then(function (data) {
					return resolveItemStatus(itemEl, data.locations || {}, holidays, base);
				})
				.catch(function () {
					return null;
				});
		});

		Promise.all(promises).then(function (results) {
			var maxLower = null;
			var maxUpper = null;

			results.forEach(function (status, i) {
				var elements = byVariant[variantIds[i]];
				var oversold = !!(status && status.oversold);

				elements.forEach(function (itemEl) {
					var warningEl = itemEl.querySelector('.cart-item-oversold-warning');
					if (!warningEl) return;
					if (oversold) {
						warningEl.textContent = 'Kun ' + status.available + ' på lager – reducér antal';
						warningEl.hidden = false;
					} else {
						warningEl.hidden = true;
					}
				});

				if (status && status.range) {
					if (maxLower === null || status.range.lower > maxLower) maxLower = status.range.lower;
					if (maxUpper === null || status.range.upper > maxUpper) maxUpper = status.range.upper;
				}
			});

			if (maxLower === null) {
				summaryEls.forEach(function (el) {
					el.hidden = true;
				});
				return;
			}

			var text = 'Ordren forventes leveret mellem ' + maxLower + '-' + maxUpper + ' hverdage';
			syncDeliveryEstimateAttribute(text);
			summaryEls.forEach(function (el) {
				var textEl = el.querySelector('.cart-delivery-estimate__text');
				if (textEl) textEl.textContent = text;
				el.hidden = false;
			});
		});
	}

	document.addEventListener('input', function (event) {
		var input = event.target;
		if (!input.classList || !input.classList.contains('qty')) return;
		var itemEl = input.closest('[data-cart-delivery-item]');
		if (!itemEl) return;
		var max = input.getAttribute('max');
		if (max === null || max === '') return;
		var maxVal = parseInt(max, 10);
		var val = parseInt(input.value, 10);
		if (!isNaN(maxVal) && !isNaN(val) && val > maxVal) {
			input.value = maxVal;
		}
	});

	document.addEventListener('line-item:change:end', updateSummary);
	document.addEventListener('cart:item-added', updateSummary);
	document.addEventListener('cart-drawer:open', updateSummary);

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', updateSummary);
	} else {
		updateSummary();
	}
})();
